import { has } from '../../utils.js';

class Trigger {
  /**
   * Transform constructor.
   * @param {array}   patch   The patch operations to check for triggers
   * @param {string}  userId  The current user id
   */
  constructor(patch, userId) {
    this.patch = patch;
    this.userId = userId;
  }

  /**
   * Trigger a series of patch operations for the patch
   * @returns {array}   The triggered patch operations
   */
  trigger() {
    const triggerPatch = [];
    this.patch.forEach(patchOp => {
      const triggered = this.triggerOp(patchOp);
      if (triggered) {
        triggerPatch.push(triggered);
      }
    });
    return triggerPatch;
  }

  /**
   * Trigger a new patch operation (config) for the specified patchOp.
   * @param {Object} patchOp
   */
  triggerOp(patchOp) {
    const { path, op } = patchOp;

    const index = path.lastIndexOf('/');
    const sPath = path.substring(0, index);
    const id = path.substring(index + 1);

    // Check if the operation is add or remove
    if (op !== 'add' && op !== 'remove') {
      return null;
    }

    if (sPath === '/data/boards/byId') {
      // Add its configuration also
      const triggeredOp = {};
      triggeredOp.op = op;
      triggeredOp.path = `/config/boards/byId/${id}`;
      if (op === 'add') {
        const { value } = patchOp;
        if (has(value, 'children')) {
          triggeredOp.value = { collapsed: false };
        } else {
          triggeredOp.value = {
            collapsed: true,
            transform: {
              scale: 1,
              x: -10000,
              y: -10000,
            },
          };
        }
      }
      triggeredOp.triggered = true;
      return triggeredOp;
    }

    // Adding or removing a new component
    if (sPath === '/data/components/byId') {
      const triggeredOp = {};
      triggeredOp.op = op;
      triggeredOp.path = `/config/components/byId/${id}`;
      if (op === 'add') {
        const { value } = patchOp;
        if (has(value, 'children')) {
          triggeredOp.value = { collapsed: false };
        } else {
          triggeredOp.value = {};
        }
      }
      triggeredOp.triggered = true;
      return triggeredOp;
    }

    // Adding or removing a new asset
    if (sPath === '/data/assets/byId') {
      const triggeredOp = {};
      triggeredOp.op = op;
      triggeredOp.path = `/config/assets/byId/${id}`;
      if (op === 'add') {
        const { value } = patchOp;
        if (has(value, 'children')) {
          triggeredOp.value = { collapsed: false };
        } else {
          triggeredOp.value = {};
        }
      }
      triggeredOp.triggered = true;
      console.log('Triggered operation is:', triggeredOp);
      return triggeredOp;
    }

    // Adding or removing a new comment
    if (sPath === '/data/comments/byId') {
      const triggeredOp = {};
      triggeredOp.op = op;
      triggeredOp.path = `/config/comments/byId/${id}`;
      if (op === 'add') {
        const { value } = patchOp;
        const { userId } = value;
        // The comment is initially read only if it is created by the current user
        const read = this.userId === userId;
        triggeredOp.value = { read };
      }
      triggeredOp.triggered = true;
      console.log('Triggered operation is:', triggeredOp);
      return triggeredOp;
    }

    return null;
  }
}

/**
 * Creates a series of triggered operations.
 */
export function trigger(patch, userId) {
  const tr = new Trigger(patch, userId);
  return tr.trigger();
}

/**
 * Filter only non-triggered operations
 * @param {array} patch
 */
export function filterNonTriggered(patch) {
  return patch.filter(
    patchOp => !has(patchOp, 'triggered') || !patchOp.triggered
  );
}
